import React from "react";
import PropTypes from "prop-types";
import {Provider} from "react-redux";
import JssProvider from "react-jss/lib/JssProvider";
import {
  MuiThemeProvider,
  createMuiTheme,
  createGenerateClassName
} from "@material-ui/core/styles";
import createStoreForSSR from "./redux";
import Root from "./components/Root";

class App extends React.Component {
  static propTypes = {
    materialUI: PropTypes.string,
    state: PropTypes.shape({
      authenticityToken: PropTypes.string,
      url: PropTypes.string,
      breadcrumbs: PropTypes.array,
      product: PropTypes.object,
      buyInOneClick: PropTypes.object,
      seo: PropTypes.object,
      location: PropTypes.object,
      reviews: PropTypes.object,
      cartInfo: PropTypes.object,
      isAdmin: PropTypes.bool
    })
  };
  // Remove the server-side injected CSS.
  componentDidMount() {
    const jssStyles = document.getElementById(
      `jss-server-side-${this.props.materialUI}`
    );
    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
    document
      .querySelector(`[data-react-class]`)
      .removeAttribute(`data-react-props`);
  }

  render() {
    const {
      state: {
        url,
        breadcrumbs,
        product,
        authenticityToken,
        buyInOneClick,
        seo,
        locationData,
        reviews,
        cartInfo,
        isAdmin,
        licenseeStore
      }
    } = this.props;
    const store = createStoreForSSR({
      url,
      breadcrumbs,
      product,
      authenticityToken,
      buyInOneClick,
      seo,
      locationData,
      reviews,
      cartInfo,
      isAdmin,
      licenseeStore
    });
    const theme = createMuiTheme({
      typography: {
        fontFamily: `"Formular", "Arial", sans-serif`,
        useNextVariants: true
      },
      breakpoints: {
        values: {
          xs: 0,
          sm: 740,
          md: 940,
          lg: 1240,
          xl: 1440
        }
      }
    });
    // Create a new class name generator.
    const generateClassName = createGenerateClassName({
      productionPrefix: `${this.props.materialUI}-react-app`
    });
    return (
      <JssProvider generateClassName={generateClassName}>
        <MuiThemeProvider theme={theme}>
          <Provider store={store}>
            <Root />
          </Provider>
        </MuiThemeProvider>
      </JssProvider>
    );
  }
}

export default App;
